import { render, staticRenderFns } from "./JingMu.vue?vue&type=template&id=280c9cfb&scoped=true"
import script from "./JingMu.vue?vue&type=script&lang=js"
export * from "./JingMu.vue?vue&type=script&lang=js"
import style0 from "./JingMu.vue?vue&type=style&index=0&id=280c9cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c9cfb",
  null
  
)

export default component.exports